// extracted by mini-css-extract-plugin
export default {"loginPage":"admin-panel_loginPage__7TVtl","login_box":"admin-panel_login_box__ERo77","background":"admin-panel_background__0y8Sm","adminPanel":"admin-panel_adminPanel__CyoMv"};